// extracted by mini-css-extract-plugin
module.exports = {"message":"InfoPopup_message__rYakX","container":"InfoPopup_container__2YhDz"};